var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { MdapSdk, CustomPlugin } from '@mdap/javascript-sdk';
var customName = '';
var customReporter;
var secretKeys = {
    live: '73c575ca86b204fac81be2de8bf505b14acd63a6e4755e84e9deba44e1253188',
    test: '32b004a142233cc3d292ab2698035ed27a05460cebbd45a6e5b631de40f6b21d',
};
export var initReporter = function (options) {
    try {
        var env = options.env || 'live';
        var region = options.region || 'sg';
        customName = options.name || '';
        var sdk = new MdapSdk({
            app_name: 'tsp-web',
            secret_key: secretKeys[env] || secretKeys.test,
            // environment值为 ‘live’ 时，数据会上报到正服环境 https://mdap.shopee.io， 为其他值时数据会上报到测服  https://mdap.exp.shopee.io
            environment: env,
            // 上报地区/Reporting Region | sg | tw | ph | th | id | my | br | mx | ...
            region: region,
            // 是否开启调试日志/Toggle of debug logger | default - false
            logger: true,
            // 业务应用版本 business application version
            app_version: '0.2.7',
            // sampling rate 采样率 - default 0.1 | 采样率控制sdk是否采样开启，如果采样命中则全引用的插件生效，否则全部不生效，采样结果会在下一次启动时(刷新或新开tab)生效 Sampling result will be effective at next startup (refresh page OR open a new tab)
            sample: 0.1
        });
        customReporter = new CustomPlugin({});
        sdk.use(customReporter);
    }
    catch (e) { }
};
export var report = function (id, value, categories) {
    try {
        customReporter === null || customReporter === void 0 ? void 0 : customReporter.sendData({
            point_id: id,
            duration: value,
            data: __assign(__assign({}, categories), { custom_name: customName })
        });
    }
    catch (e) { }
};
//# sourceMappingURL=mdap.js.map